import type { PresaleAttributes as GQLInput } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** What a caller hands `toGqlInput`. No `id` creates, an `id` updates. */
export type PresaleInput = {
  id?: number | null;
  eventId: number;
  name?: string | null;
  password?: string | null;
  sellStart: string;
  sellEnd: string;
  showUpcomingInfo?: boolean | null;
  ticketBlueprintIds?: number[] | null;
};

const GQL_FIELDS = [
  'eventId', 'id', 'name', 'password', 'sellEnd', 'sellStart', 'showUpcomingInfo',
  'ticketBlueprintIds',
] as const;

/**
 * Drops what the mutation rejects: a form seeded from a read still carries the read-only `link`,
 * `url` and `active`, and an unknown argument fails the whole call.
 */
export const toGqlInput = (input: PresaleInput): GQLInput =>
  take<GQLInput, PresaleInput>(input, ...GQL_FIELDS);
